/**
 * Gravun brand configuration, the single source of truth for product
 * branding. Do not scatter the product name or logo paths through the
 * codebase; import from here (or receive them via the CRM configuration
 * context, which App.tsx feeds from this module).
 *
 * Future white-labeling (per-workspace logos, custom sender identities,
 * custom domains) extends this module rather than replacing usages inline.
 */
import gravunLogoDark from "./logos/gravun-dark.svg";
import gravunLogoLight from "./logos/gravun-light.svg";
import gravunWordmarkNavy from "./logos/gravun-wordmark-navy.png";
import gravunWordmarkWhite from "./logos/gravun-wordmark-white.png";
import gravunAppIconNavy from "./logos/gravun-appicon-navy.png";

export const GRAVUN_BRAND = {
  /** Product name shown in the header, page titles, and emails. */
  name: "Gravun",
  /** One-line positioning used on auth/marketing surfaces. */
  tagline: "Run your service business from one platform.",
  /** Supporting copy used on auth surfaces (matches app.gravun.com). */
  authSubline:
    "Manage customers, invoices, payments, communications and operations in one clean workspace.",
  /** Mark-only logo shown on light backgrounds. */
  lightModeLogo: gravunLogoLight,
  /** Mark-only logo shown on dark backgrounds. */
  darkModeLogo: gravunLogoDark,
  /** Full GRAVUN wordmark (official brand asset) for light backgrounds. */
  wordmarkNavy: gravunWordmarkNavy,
  /** Full GRAVUN wordmark (official brand asset) for dark/navy backgrounds. */
  wordmarkWhite: gravunWordmarkWhite,
  /** Rounded-square navy app icon (favicons, avatars, mobile). */
  appIcon: gravunAppIconNavy,
} as const;
